import { Component, forwardRef } from '@angular/core';
import type { ControlValueAccessor} from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * Boolean toggle control that integrates with Angular's ControlValueAccessor for reactive forms.
 */
@Component({
  selector: 'es-checkbox',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxComponent),
    multi: true,
  }],
  template: `
    <label class="inline-flex items-center gap-2 cursor-pointer text-sm text-[var(--text-secondary)] hover:text-[var(--text)] transition-colors">
      <input
        type="checkbox"
        [checked]="value"
        [disabled]="isDisabled"
        class="w-4 h-4 rounded border-[var(--border)] bg-[var(--bg-secondary)] text-echo-blue focus:ring-echo-blue/30 cursor-pointer"
        (change)="toggle()"
      />
      <ng-content></ng-content>
    </label>
  `,
})
export class CheckboxComponent implements ControlValueAccessor {
  value = false;
  isDisabled = false;
  onChange: (value: boolean) => void = () => {
    // noop — replaced by registerOnChange/registerOnTouched
  };
  onTouched: () => void = () => {
    // noop — replaced by registerOnChange/registerOnTouched
  };

  writeValue(value: boolean): void { this.value = !!value; }
  registerOnChange(fn: (value: boolean) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState(disabled: boolean): void { this.isDisabled = disabled; }

  toggle(): void {
    this.value = !this.value;
    this.onChange(this.value);
    this.onTouched();
  }
}
